export default __webpack_public_path__ + "static/media/dg-gallery-01.8419c914.jpg";